import { TFunction } from '@lyearn/i18n';
import { UpdateQuestionEntity } from '@/types/schema';

const validateMatchTheFollowing = (t: TFunction, question?: UpdateQuestionEntity) => {
  const mtfComponent = question?.mtfComponent;
  const emptyLeftElements =
    mtfComponent?.leftElements.filter((leftElement) => !leftElement.text) || [];
  const emptyRightElements =
    mtfComponent?.rightElements.filter((rightElement) => !rightElement.text) || [];
  const emptyElementsLength = emptyLeftElements.length + emptyRightElements.length;

  if (mtfComponent?.leftElements.length === 0) {
    return {
      message: t('QuizCreator:Validations.AddAtleastOneClueMatch'),
      type: 'AddAtleastOneClueMatch',
    };
  }

  if (emptyElementsLength !== 0) {
    return {
      message: t('QuizCreator:Validations.OptionCannotBeEmpty', { count: emptyElementsLength }),
      type: 'OptionCannotBeEmpty',
    };
  }

  const isAnyIncorrectOptionEmpty =
    question?.globalDistractors?.set.findIndex((distractor) => !Boolean(distractor.text)) !== -1;
  if (isAnyIncorrectOptionEmpty) {
    return {
      message: t('QuizCreator:Validations.DistractorCantBeEmpty'),
      type: 'QuestionSettings',
    };
  }
};

export default validateMatchTheFollowing;
